import LogoutIcon from '@mui/icons-material/Logout';
import { colors } from '@mui/material';
import { useCallback } from 'react';
import { MenuItemLink, useLogout } from 'react-admin';

export const UserMenuLogoutButton = ({ testId }: { testId?: string }) => {
  const logout = useLogout();
  const handleClick = useCallback(async () => {
    await logout();
  }, [logout]);

  return (
    <MenuItemLink
      onClick={handleClick}
      leftIcon={<LogoutIcon sx={{ color: colors.red[500] }} />}
      primaryText="profile_popup.logout"
      sx={{ color: `${colors.red[500]} !important`, fontWeight: '500' }}
      to=""
      data-testid={testId}
    />
  );
};
